import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DcrSheetPage } from '@/features/product/pages/DcrSheetPage';
import { dcrSheetSearchSchema } from '@/features/product/types/product.types';

export const Route = createFileRoute('/_auth/product/dcr-date-to-date')({
  validateSearch: dcrSheetSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="View DCR Date to Date">
      <Suspense fallback={<PageLoader />}>
        <DcrSheetPage routeId="range" title="View DCR Date to Date" shouldShowApprovedOnly={true} />
      </Suspense>
    </ErrorBoundary>
  ),
});
